import { useStyletron } from 'baseui';

export function Filter3D({ dirty, height, width }: any) {
    const [, theme] = useStyletron();
    const fillForeground = dirty ? theme.colors.warning : theme.colors.primary400;
    const fillBackground= dirty ? theme.colors.warning600 : "#A0A0A0";

    return (
        <svg width={width || '100%'} height={height || '100%'} viewBox="0 0 100 100">
            <path id="filter_face" d="M 80,00 L50,30 L50,100 L80,70" fill={fillBackground}></path>

            <path d="M 50,38 L80,8 L80,12 L50,42  Z" fill={fillForeground}></path>
            <path d="M 50,48 L80,18 L80,22 L50,52 Z" fill={fillForeground}></path>
            <path d="M 50,58 L80,28 L80,32 L50,62 Z" fill={fillForeground}></path>
            <path d="M 50,68 L80,38 L80,42 L50,72 Z" fill={fillForeground}></path>
            <path d="M 50,78 L80,48 L80,52 L50,82 Z" fill={fillForeground}></path>
            <path d="M 50,88 L80,58 L80,62 L50,92 Z" fill={fillForeground}></path>

            <path d="M 50,76.66 L70,10" stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>
            <path d="M 50,53.33 L60,20" stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>
            <path d="M 50,100 L80,0   " stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>
            <path d="M 60,90 L80,23.33" stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>
            <path d="M 70,80 L80,46.66" stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>

            <path d="M 50,76.66 L60,90" stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>
            <path d="M 50,53.33 L70,80" stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>
            <path d="M 50,30 L80,70   " stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>
            <path d="M 60,20 L80,46.66" stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>
            <path d="M 70,10 L80,23.33" stroke="#D0D0D0" strokeWidth="1" strokeLinejoin="round"></path>

            <path id="filter_frameTop" d="M 70,0 L40,30 L50,30 L80,0" fill="#C0C0C0"></path>
            <path id="filter_frameFront" d="M 40,30 L40,100 L50,100 L50,30" fill="#A0A0A0"></path>
        </svg>
    );
}